var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 21",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.53 4.832a.75.75 0 010 1.06l-10 10a.75.75 0 01-1.06-1.06l10-10a.75.75 0 011.06 0z",
    fill: "#48525C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.47 4.832a.75.75 0 011.06 0l10 10a.75.75 0 11-1.06 1.06l-10-10a.75.75 0 010-1.06z",
    fill: "#48525C"
  })));
};
export default SvgClose;